(function () {
  'use strict';
  const MAX_AGE = 4 * 60 * 60;
  function isCurrent(checked, expires, now) {
    const last = Number(checked);
    const end = expires ? Number(expires) : null;
    return Number.isFinite(last) && last > 0 && last <= now && now - last < MAX_AGE &&
      (end === null || (Number.isFinite(end) && end > now));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { isCurrent };
  if (typeof document === 'undefined') return;
  function update() {
    const now = Date.now() / 1000;
    document.querySelectorAll('[data-deal-list]').forEach(section => {
      let shown = 0;
      const limit = Number(section.querySelector('[data-deal-limit]')?.dataset.dealLimit || 3);
      section.querySelectorAll('[data-deal]').forEach(card => {
        const visible = shown < limit && isCurrent(card.dataset.checked, card.dataset.expires, now);
        card.hidden = !visible;
        if (visible) shown++;
      });
      section.hidden = shown === 0;
    });
    const results = document.querySelector('[data-deal-results]');
    if (results) {
      const filter = document.querySelector('[data-deal-filter][aria-pressed="true"]')?.dataset.dealFilter || 'all';
      let count = 0;
      results.querySelectorAll('[data-deal]').forEach(card => {
        const visible = (filter === 'all' || card.dataset.category === filter) && isCurrent(card.dataset.checked, card.dataset.expires, now);
        card.hidden = !visible;
        if (visible) count++;
      });
      const empty = document.querySelector('[data-deal-empty]');
      if (empty) empty.hidden = count > 0;
    }
    document.querySelectorAll('[data-deal-detail]').forEach(detail => {
      const live = detail.dataset.approved === 'true' && isCurrent(detail.dataset.checked, detail.dataset.expires, now);
      detail.querySelector('[data-deal-live]').hidden = !live;
      detail.querySelector('[data-deal-stale]').hidden = live;
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-deal-filter]');
    if (!button) return;
    document.querySelectorAll('[data-deal-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    update();
  });
  update();
  window.setInterval(update, 60000);
})();
